import { db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

export const fetchQuestionsByTestId = async (testId) => {
  const docRef = doc(db, "questions", testId);
  const docSnapshot = await getDoc(docRef);

  if (!docSnapshot.exists()) {
    return [];
  }

  const data = docSnapshot.data();
  return data.questions || [];
};
